import React, { useState, useEffect, useRef } from "react";

import { func_validation, getStringUniqueId, isArrayNotEmpty } from "functions";

import "assets/scss/components/informational/submenuPopover.scss";



export function SubmenuPopover(props) {
    const { className, triggerClassName, trigger, triggerPosition, menu } = props;

    // Validate Props

    let trigger_validated = func_validation.isNotNullUndefined(trigger)? trigger: "";
    let triggerPosition_validated = "justify-content-start";
    switch(triggerPosition) {
        case "right":
            triggerPosition_validated = "justify-content-end"; break;
        case "center":
            triggerPosition_validated = "justify-content-center"; break;
    }

    // Element ID
    const triggerId = useRef(getStringUniqueId("trigger"));
    const menuItemIds = useRef(isArrayNotEmpty(menu)? menu.map(() => getStringUniqueId("menuItem")):[]);

    // States
    const isSubmenuVisible = useRef();
    const [isRerenderRequired, setIsRerenderRequired] = useState();

    // Reset
    useEffect(() => {
        if (isRerenderRequired) setIsRerenderRequired(false);
    }, [isRerenderRequired])

    function toggleSubmenu(e) {
        let triggerEle = document.getElementById(triggerId.current);

        // Check if submenu is selected
        let isSubmenuClicked = false;
        if (isArrayNotEmpty(menuItemIds?.current)) {
            menuItemIds.current.map((id) => {
                let menuItemEle = document.getElementById(id);

                if (menuItemEle?.contains(e?.target)) {
                    isSubmenuClicked = true;
                }
            })
        }

        if (triggerEle?.contains(e?.target)) {
            isSubmenuVisible.current = !(isSubmenuVisible.current);
            setIsRerenderRequired(true); 
        }
        else if (isSubmenuClicked) {
        }
        else {
            isSubmenuVisible.current = false;
            setIsRerenderRequired(true); 
        } 
    }
    useEffect(() => {
        window.addEventListener("click", toggleSubmenu);
        return () => {
            window.removeEventListener("click", toggleSubmenu);
        }
    }, []);

    let menuDisplay = "";
    if (func_validation.isArrayNotEmpty(menu)) {
        menuDisplay = menu.map((itemObj, idx) => {
            let label = func_validation.getObjectPropertyValue(itemObj, "label", "");
            let callbackFunc = func_validation.getObjectPropertyValue(itemObj, "callbackFunc");

            if (func_validation.isNotNullUndefined(label)) {
                return (
                    <div key={idx} id={menuItemIds?.current[idx]} className={"component-submenuPopover-menuItem"}
                        onClick={callbackFunc}
                    >
                        {label}
                    </div>
                )
            }
            else return "";
        })
    }

    return(
        <div className={"component-submenuPopover " +
                (className? className + " ":"")}
        >
            {/* Trigger Position */}
            <div className={"component-submenuPopover-triggerWrapper " +
                    (triggerPosition_validated? triggerPosition_validated + " ":"") +
                    (isSubmenuVisible.current? "component-submenuPopover-triggerWrapper_submenuVisible ":"")}
            >
                {/* Trigger */}
                <div id={triggerId.current} className={"component-submenuPopover-trigger " +
                        (triggerClassName? triggerClassName + " ":"")}>
                    {trigger_validated}
                </div>

                {/* Menu */}
                {isSubmenuVisible.current? (
                    <div className={"component-submenuPopover-menu"}>{menuDisplay}</div>
                ):""}
            </div>
        </div>
    )
}